import { useState } from 'react';

export default function InstagramCTA() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-[#f8faf5] to-[#e8f0dc] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-[#9bc53d]/20 to-transparent rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-[#2d5016]/10 to-transparent rounded-full translate-y-1/2 -translate-x-1/2"></div>
          
          <div className="relative grid lg:grid-cols-2 gap-8 lg:gap-0">
            <div className="p-8 sm:p-10 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#f09433] via-[#e6683c] to-[#bc1888] rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-instagram-line text-2xl text-white"></i>
                </div>
                <span className="text-[#2d5016] font-bold text-lg">@ranchodaverdura</span>
              </div>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2d5016] mb-4 leading-tight">
                Siga-nos no <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#f09433] via-[#e6683c] to-[#bc1888]">Instagram</span>
              </h2>
              
              <p className="text-gray-600 text-base sm:text-lg mb-8 leading-relaxed">
                Acompanhe as novidades, promoções exclusivas e veja os bastidores do nosso dia a dia. Fique por dentro de tudo que acontece no Rancho da Verdura!
              </p>
              
              <div className="flex flex-wrap gap-3 mb-8">
                <span className="px-4 py-2 bg-[#f8faf5] text-[#2d5016] rounded-full text-sm font-medium">
                  🥬 Produtos Frescos
                </span>
                <span className="px-4 py-2 bg-[#f8faf5] text-[#2d5016] rounded-full text-sm font-medium">
                  🎉 Promoções
                </span>
                <span className="px-4 py-2 bg-[#f8faf5] text-[#2d5016] rounded-full text-sm font-medium">
                  📸 Bastidores
                </span>
              </div>
              
              <a
                href="https://www.instagram.com/ranchodaverdura"
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className="group inline-flex items-center gap-3 bg-gradient-to-r from-[#f09433] via-[#e6683c] to-[#bc1888] text-white px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer w-fit whitespace-nowrap"
              >
                <i className={`ri-instagram-line text-2xl transition-transform duration-300 ${isHovered ? 'animate-pulse' : ''}`}></i>
                Seguir Agora
                <i className={`ri-arrow-right-line text-xl transition-transform duration-300 ${isHovered ? 'translate-x-1' : ''}`}></i>
              </a>
            </div>
            
            <div className="relative h-80 lg:h-auto min-h-[400px]">
              <div className="absolute inset-0 grid grid-cols-2 gap-2 p-4 lg:p-6">
                <div className="space-y-2">
                  <div className="relative overflow-hidden rounded-2xl h-[45%] group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/670b7ac614c3f99c8541de9683c1afb4.png"
                      alt="Rancho da Verdura"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                      <i className="ri-instagram-line text-3xl text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                    </div>
                  </div>
                  <div className="relative overflow-hidden rounded-2xl h-[55%] group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/285a03b7cc3af3b5f59ca3673c66158f.png"
                      alt="Verduras Frescas"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                      <i className="ri-instagram-line text-3xl text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                    </div>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="relative overflow-hidden rounded-2xl h-[55%] group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/dee8f748c0c5adf5d4eea9582c6a8d5c.png"
                      alt="Sucos Naturais"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                      <i className="ri-instagram-line text-3xl text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                    </div>
                  </div>
                  <div className="relative overflow-hidden rounded-2xl h-[45%] group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/b08c6d67cf554a97b8efcea4334154af.png"
                      alt="Produtos do Rancho"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                      <i className="ri-instagram-line text-3xl text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
